<template>
  <section class="loading_wrapper" v-if="this.$store.getters['loading/loading']">
    <div class="loading">
      <loading-progress
        :progress="progress"
        :indeterminate="false"
        :counter-clockwise="false"
        :hide-background="false"
        size="64"
        rotate
        fill-duration="1"
        rotation-duration="2"
      />
      <p class="blink">Now Loading ...</p>
    </div>
  </section>
</template>

<script>
export default {
  name: "Loading",
  data: function() {
    return {
      issued: false,
      progress: 0
    }
  },
  computed: {
    /**
     * イベント
     * @return {*}
     */
    event() {
      return this.$store.getters["event/event"]
    },
    /**
     * 参加者
     * @return {*}
     */
    participants() {
      return this.$store.getters["participants/all"]
    },
    /**
     * ログインユーザー
     * @return {*}
     */
    authUser() {
      return this.$store.getters["auth/user"]
    },
    /**
     * ダイレクトメッセージ
     * @return {*}
     */
    dm() {
      return this.$store.getters["directMessages/all"]
    },
    /**
     * ホール
     * @return {*}
     */
    hall() {
      return this.$store.getters["hall/all"]
    },
    /**
     * コーナー
     * @return {*}
     */
    corner() {
      return this.$store.getters["corner/all"]
    },
    /**
     * ルーム
     * @return {*}
     */
    room() {
      return this.$store.getters["room/all"]
    },
    progressCount() {
      const countAll = this.$store.getters["progress/countAll"]
      const readiedCount = this.$store.getters["progress/readiedCount"]

      if (this.$store.getters["loading/loading"] && countAll === readiedCount) {
        this.unsetLoading()
      }
      return this.$store.getters["progress/readiedCount"]
    }
  },
  watch: {
    /**
     * computedのeventを監視
     */
    event() {
      this.$store.dispatch("progress/readyEvent")
    },
    /**
     * computedのdmを監視
     */
    dm() {
      this.$store.dispatch("progress/readyDm")
    },
    /**
     * computedのhallを監視
     */
    hall() {
      this.$store.dispatch("progress/readyHall")
    },
    /**
     * computedのcornerを監視
     */
    corner() {
      this.$store.dispatch("progress/readyCorner")
    },
    /**
     * computedのroomを監視
     */
    room() {
      this.$store.dispatch("progress/readyRoom")
    },
    /**
     * computedのparticipantsを監視
     */
    participants() {
      this.$store.dispatch("progress/readyParticipant")
    },
    /**
     * computedのauthUserを監視
     */
    authUser() {
      this.$store.dispatch("progress/readyUser")
    },
    progressCount() {
      const countAll = this.$store.getters["progress/countAll"]
      const readiedCount = this.$store.getters["progress/readiedCount"]

      this.progress = readiedCount / countAll
    }
  },
  created() {
    const key = "tab"
    let local = this.$sl.get(key)
    let session = sessionStorage.getItem(key)

    // session storageを正としてみていく
    // ※ ページのセッションはブラウザを開いている限り、ページの再読み込みや復元を越えて持続し、
    //    新しいタブやウィンドウにページを開くと、新しいセッションが開始します。
    // session storageにタブIDが発行されていない、または値が一致していても、発行フラグがfalseの場合
    if (_.isNull(session) || (session === local && !this.issued)) {
      const id = this.$moment.now().toString()
      this.$sl.set(key, id)
      sessionStorage.setItem(key, id)
      this.issued = true
    }

    setInterval(() => {
      if (this.$route.name === "AccessDenied") return

      local = this.$sl.get(key)
      session = sessionStorage.getItem(key)

      // session storageとlocal storageの値が一致していない場合は403画面へ遷移
      if (session !== local) {
        if (!this.$config.app.debug) {
          this.$router.push({name: "AccessDenied"})
        }
      }
    }, 250)
  },
  methods: {
    unsetLoading() {
      setTimeout(() => {
        this.$store.commit("loading/setLoading", false)
        this.$store.dispatch("progress/reset")
        this.progress = 0
      }, 1000)
    }
  }
}
</script>
